/**
 * Shop the Look products should open the PDP (“Ver detalles”) instead of
 * instant-adding to cart. Live Search often returns them as ProductSearchProduct
 * without a GroupedProduct __typename, so we also match url_key / name.
 */
export function isShopTheLookProduct(product: {
    __typename?: string | null
    url_key?: string | null
    name?: string | null
}): boolean {
    if (product.__typename === 'GroupedProduct') return true

    const haystack = `${product.url_key ?? ''} ${product.name ?? ''}`.toLowerCase()
    return /shop[\s_-]*the[\s_-]*look/.test(haystack)
}
